import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { preloadI18n, DEFAULT_NAMESPACES } from "./translations.local";
import { env } from "../../config/env";

function normalizeLanguage(lang: string): string {
  const available = env.AVAILABLE_LANGUAGES;
  const match = available.find(
    (l) => l === lang || l.startsWith(lang.split("-")[0]),
  );
  if (match) return match;

  const prefixMatch = available.find(
    (l) => l.split("-")[0] === lang.split("-")[0],
  );
  if (prefixMatch) return prefixMatch;

  return env.DEFAULT_LANGUAGE || "pt-BR";
}

function detectLanguage(): string {
  const systemLang = localStorage.getItem("appLanguage");
  if (systemLang) return normalizeLanguage(systemLang);

  if (env.LANGUAGE_SELECTOR_ENABLED) {
    const userLang = localStorage.getItem("userLanguage");
    if (userLang) return normalizeLanguage(userLang);

    return normalizeLanguage(
      navigator.language || env.DEFAULT_LANGUAGE || "pt-BR",
    );
  }

  return env.DEFAULT_LANGUAGE || "pt-BR";
}

i18n.use(initReactI18next).init({
  lng: detectLanguage(),
  fallbackLng: env.DEFAULT_LANGUAGE || "pt-BR",
  supportedLngs: [...env.AVAILABLE_LANGUAGES],
  ns: [...DEFAULT_NAMESPACES],
  defaultNS: "common",
  interpolation: {
    escapeValue: false,
  },
  resources: {},
});

export async function initI18nWithTenant(
  productId: string = env.PRODUCT_ID,
  clientId?: string,
): Promise<void> {
  const lng = i18n.language || env.DEFAULT_LANGUAGE || "pt-BR";
  await preloadI18n(
    i18n,
    lng,
    [...DEFAULT_NAMESPACES],
    productId,
    clientId || env.CLIENT_ID || undefined,
  );
}

export async function changeLanguageWithTenant(
  newLng: string,
  productId: string = env.PRODUCT_ID,
  clientId?: string,
): Promise<void> {
  await preloadI18n(
    i18n,
    newLng,
    [...DEFAULT_NAMESPACES],
    productId,
    clientId || env.CLIENT_ID || undefined,
  );
  await i18n.changeLanguage(newLng);
}

export const DAYJS_LOCALE_MAP: Record<string, string> = {
  "pt-BR": "pt-br",
  "pt-PT": "pt",
  "en-US": "en",
  "es-ES": "es",
};

export { preloadI18n, DEFAULT_NAMESPACES } from "./translations.local";
export default i18n;
